import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: flex-start;
  padding-top: 70px;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  padding: 70px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .logo {
    width: 240px;
    height: auto;
    margin-bottom: 100px;
  }

  .title {
    font-size: 36px;
    line-height: 1.1;
    font-weight: 700;
    color: #0d875e;
    margin: 0 0 18px;
    text-align: center;
  }

  .subtitle {
    font-size: 20px;
    color: #6b6b6b;
    margin: 0 0 34px;
    text-align: center;
    max-width: 760px;
    font-weight: 300;
  }

  .actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .btn-support {
    padding: 12px 34px;
    background-color: #0d875e;
    border-radius: 10px;
    font-weight: 600;
    border: none;
    min-width: 220px;
  }

  .support-hours {
    font-size: 12px;
    color: #8c8c8c;
    text-align: center;
    line-height: 1.35;
    margin-top: 2px;
  }

  /* Mobile */
  @media (max-width: 768px) {
    padding: 50px 16px;

    .logo {
      width: 200px;
      margin-bottom: 50px;
    }

    .title {
      font-size: 28px;
    }

    .subtitle {
      font-size: 15px;
      margin-bottom: 28px;
    }

    .btn-support {
      width: 100%;
      max-width: 260px;
    }
  }
`;
